import axios from 'axios'

export default {
  namespaced: true,

  state: {
    games: [],
    types: [],
    count: 0
  },

  getters: {
    all (state) {
      return state.games
    },

    types (state) {
      return state.types
    },

    count (state) {
      return state.count
    }
  },

  mutations: {
    SET_GAMES (state, games) {
      state.games = games
    },

    SET_COUNT (state, count) {
      state.count = count
    },

    SET_GAME_TYPES (state, types) {
      state.types = types
    },

    UPDATE_GAME (state, game) {
      let index = state.games.findIndex((row) => { return row.id === game.id })
      if (index !== -1) {
        state.games[index] = game
      }
    },

    DELETE_GAME (state, id) {
      let index = state.games.findIndex((row) => { return row.id === id })

      if (index !== -1) {
        state.games.splice(index, 1)
      }
    }
  },

  actions: {
    async get ({ commit }, { params, status, type }) {
      let url = `/games`

      if (status) {
        url += `/status/${status}`
      }

      if (status) {
        url += `/type/${type}`
      }

      let games = await axios.get(url, params ? { params } : params)
      commit('SET_GAMES', games.data)
    },

    async create ({ commit }, games) {
      let data = new FormData()

      for (const key in games) {
        if (!games.hasOwnProperty(key)) {
          continue
        }

        data.append(key, games[key])
      }

      await axios.post('/games', data)
    },

    async update ({ commit }, game) {
      let data = new FormData()
      let id = game.id
      game = Object.assign({}, game, { id: undefined })

      for (const key in game) {
        if (!game.hasOwnProperty(key) || game[key] === undefined) {
          continue
        }

        data.append(key, game[key])
      }

      await axios
        .patch(`/games/${id}`, data)
      commit('UPDATE_GAME', data)
    },

    async delete ({ commit }, id) {
      await axios.delete(`/games/${id}`)
      commit('DELETE_GAME', id)
    },

    async getTypes ({ commit }, params) {
      let types = await axios.get('/games/types', params)
      commit('SET_GAME_TYPES', types.data)
    },

    async getCount ({ commit }, params) {
      let count = await axios.get('/games/count', { params })
      commit('SET_COUNT', count.data)
    }
  }
}
